import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Ethnicity } from "../../models/ethnicity";
import {Http, Response} from "@angular/http";
import {UtilService} from "../util";

@Injectable()
export class EthnicityService {
  constructor(private http: Http, private utilService: UtilService) {}


  getEthnicity(): Observable<Array<Ethnicity>> {
    let url:string = "/core/ethnicities";

    return this.http
      .get(url)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ethnicity/ethnicity.service.ts